module.exports = __webpack_public_path__ + "img/BANNER-CORE-VALUE-01.e30250d7.png";